/* ==========================================================================
# Custom Slider
========================================================================== */

// Initialize custom sliders after Flickity is loaded
document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.Flickity === 'undefined') {
    console.warn('Flickity not loaded - custom slider initialization skipped');
    return;
  }

  var customSlidersContainer = document.querySelectorAll(
    ".custom-slider-container"
  );

  customSlidersContainer.forEach((customContainer) => {
    var prevButton = customContainer.querySelector(".flkty-prev-button");
    var nextButton = customContainer.querySelector(".flkty-next-button");

    var customSliders = customContainer.querySelectorAll(".custom-slider");

    customSliders.forEach((slider) => {
      if (slider.dataset.customSliderInitialized) return;
      slider.dataset.customSliderInitialized = "true";

      var flickityOptions = slider.getAttribute("data-flickity");
      flickityOptions = flickityOptions.replace(/'/g, '"');
      flickityOptions = JSON.parse(flickityOptions);

      var flkty = new window.Flickity(slider, flickityOptions);

      var manualdiv = document.querySelectorAll(".flickity-cell");

      function syncAriaHidden(div) {
        var link = div.querySelector("a");
        var isAriaHidden = div.getAttribute("aria-hidden") === "true";

        if (isAriaHidden) {
          link.setAttribute("aria-hidden", "true");
          link.setAttribute("tabindex", "-1");
        } else {
          link.removeAttribute("aria-hidden");
          link.removeAttribute("tabindex");
        }
      }

      manualdiv.forEach((div) => {
        var observer = new MutationObserver(() => {
          syncAriaHidden(div);
        });

        observer.observe(div, {
          attributes: true,
          attributeFilter: ["aria-hidden"],
        });
      });

      flkty.on("select", () => {
        manualdiv.forEach(syncAriaHidden);
      });

      manualdiv.forEach(syncAriaHidden);
      var slides = slider.querySelectorAll(".carousel-cell");

      // Function to handle button opacity based on selected slide
      function handleButtonOpacity() {
        var isFirstSlideSelected = flkty.selectedIndex === 0;
        var isLastSlideSelected = flkty.selectedIndex === slides.length - 1;

        if (isFirstSlideSelected) {
          prevButton.classList.add("opacity-40", "pointer-events-none");
        } else {
          prevButton.classList.remove("opacity-40", "pointer-events-none");
        }

        if (isLastSlideSelected) {
          nextButton.classList.add("opacity-40", "pointer-events-none");
        } else {
          nextButton.classList.remove("opacity-40", "pointer-events-none");
        }
      }

      function checkButtonOpacity() {
        if (!flickityOptions.wrapAround) {
          handleButtonOpacity();
        }
      }

      // Check on page load
      checkButtonOpacity();

      // Event listeners for button clicks
      prevButton.addEventListener("click", function () {
        flkty.previous();
        checkButtonOpacity();
      });

      nextButton.addEventListener("click", function () {
        flkty.next();
        checkButtonOpacity();
      });

      // Update opacity when the slide changes
      flkty.on("select", function () {
        checkButtonOpacity();
      });
    });
  });
});
